import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-b border-line bg-canvasAlt" data-id="element-39" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-2xl px-4 py-9 sm:px-6" data-id="element-40" data-mp="2bl5mccbi5rn8">
        <h2 id="faq" className="text-center font-display text-lg font-extrabold uppercase text-ink sm:text-xl" data-id="element-41" data-mp="2fm7ek97053fp">
          Preguntas frecuentes
        </h2>

        <div className="mt-4 space-y-2" data-id="element-42" data-mp="26t42a483ewmn">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <Reveal key={faq.q} delay={i * 0.02} className="rounded-xl border border-line bg-surface" data-id="element-43" data-mp="2uhne2tqcprjh" data-mpi={i}>
                <h3 data-id="element-44" data-mp="1vozt2p69kpel">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left" data-id="element-45" data-mp="1vqatqg4exh1h">
                    <span className="text-sm font-semibold text-ink" data-id="element-46" data-mp="2fdqkm4prnpq8">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-accent transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-47" data-mp="2afgqzyjowx6q" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-48" data-mp="u173t7r6pehh">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-49" data-mp="p2dza4tvkxtg">
                      <p className="px-4 pb-3 text-xs leading-relaxed text-ink-muted sm:text-sm" data-id="element-50" data-mp="333ll75jbcfel">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}